import {
  TableBody,
  TableRow,
  TableCell,
  Toolbar,
  InputAdornment,
  IconButton,
  Button,
} from '@mui/material'
import { makeStyles } from '@material-ui/styles'
import { Add, Search, Edit, Delete } from '@mui/icons-material'
import Swal from 'sweetalert2'

import useTable from '../UI/Table'

import { useState } from 'react'
import BlogForm from './form'
import { CustomDialog } from '../UI/Dialog'
import Controls from '../UI/Controls'
import { deleteBlog, useBlog } from '../../services/blog'

const headCells = [
  { id: 'titulo', label: 'Titulo' },
  { id: 'fecha', label: 'Fecha' },
  { id: 'tipo', label: 'Tipo' },
  { id: 'acciones', label: 'Acciones' },
]

const useStyles = makeStyles(() => ({
  searchInput: {
    width: '100%',
  },
  toolBar: {
    justifyContent: 'space-between',
  },
  '@media (max-width: 700px)': {
    toolBar: {
      display: 'list-item',
      flexWrap: 'wrap',
    },
    margin: {
      marginTop: '20px',
    },
  },
}))

export const Blog = () => {
  const [blogs] = useBlog()

  const classes = useStyles()

  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items
    },
  })

  const { TblContainer, TblHead, TblPagination, recordAfterPagingAndSorting } =
    useTable(blogs, headCells, filterFn)

  const [open, setOpen] = useState(false)
  const [update, setUpdate] = useState({})
  const [flag, setFlag] = useState(false)

  const handleSearch = ({ target }) => {
    const { value } = target
    setFilterFn({
      fn: (items) => {
        if (target.value === '') return items
        else
          return items.filter((x) =>
            x.titulo.toLowerCase().includes(value.toLowerCase())
          )
      },
    })
  }

  return (
    <>
      <div style={{ marginTop: '3%' }} className="with-navbar">
        <h2 className="h1">Blog</h2>
      </div>
      <div className="form" style={{ marginTop: '15px', marginBottom: '30px' }}>
        <Toolbar className={classes.toolBar}>
          <div
            className="medium-group"
            style={{ display: 'flex', justifyContent: 'center' }}
          >
            <Controls.Input
              variant="standard"
              className={classes.searchInput}
              placeholder="Buscar Noticia"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Search />
                  </InputAdornment>
                ),
                disableUnderline: true,
              }}
              onChange={handleSearch}
            />
          </div>
          <div
            className="medium-group"
            style={{ display: 'flex', justifyContent: 'flex-end' }}
          >
            <Button
              variant="contained"
              startIcon={<Add />}
              sx={{
                backgroundColor: '#009696',
                padding: '12px 15px',
                height: '40px',
                fontSize: '1em;',
                border: '1px solid #00544e',
                borderRadius: '30px',
                transition: '0.3s all ease',
                color: 'secondary',
                '&:hover': {
                  backgroundColor: '#00544e',
                  border: '1px solid #009696',
                },
                '@media (max-width: 514px)': {
                  marginTop: '20px',
                },
              }}
              onClick={() => {
                setOpen(true)
                setUpdate({})
                setFlag(false)
              }}
            >
              Agregar
            </Button>
          </div>
        </Toolbar>
        <TblContainer>
          <TblHead />
          <TableBody>
            {recordAfterPagingAndSorting().map((blog) => (
              <TableRow key={blog.id}>
                <TableCell
                  data-label="Fecha: "
                  style={{ fontSize: '14px', fontFamily: 'Nunito' }}
                >
                  {blog.fechaPublicacion}
                </TableCell>
                <TableCell
                  data-label="Titulo: "
                  style={{ fontSize: '14px', fontFamily: 'Nunito' }}
                >
                  {blog.titulo}
                </TableCell>
                <TableCell
                  data-label="Tipo: "
                  style={{ fontSize: '14px', fontFamily: 'Nunito' }}
                >
                  {blog.tipo}
                </TableCell>
                <TableCell
                  data-label="Acciones: "
                  style={{ fontSize: '14px', fontFamily: 'Nunito' }}
                >
                  <IconButton
                    onClick={() => {
                      setUpdate(blog)
                      setFlag(true)
                      setOpen(true)
                    }}
                    sx={{
                      backgroundColor: 'orange',
                      color: 'white',
                      height: '30px',
                      width: '30px',
                      transition: '0.3s all ease',
                      marginRight: '5px',
                      '&:hover': {
                        backgroundColor: 'darkorange',
                        border: '1px solid orange',
                      },
                    }}
                  >
                    <Edit sx={{ width: '20px', height: '20px' }} />
                  </IconButton>
                  <IconButton
                    onClick={() => {
                      Swal.fire({
                        title: '¿Estas seguro de eliminar este registro?',
                        showDenyButton: true,
                        showCancelButton: false,
                        confirmButtonText: 'Sí',
                        denyButtonText: 'No',
                      }).then((result) => {
                        if (result.isConfirmed) {
                          deleteBlog(blog.id)
                          Swal.fire(
                            'Hecho',
                            'Registro eliminado exitosamente',
                            'success'
                          )
                        } else if (result.isDenied) {
                          Swal.fire('Operación abortada', '', 'info')
                        }
                      })
                    }}
                    sx={{
                      backgroundColor: 'red',
                      color: 'white',
                      height: '30px',
                      width: '30px',
                      transition: '0.3s all ease',
                      marginRight: '5px',
                      '&:hover': {
                        backgroundColor: 'darkred',
                        border: '1px solid red',
                      },
                    }}
                  >
                    <Delete sx={{ width: '20px', height: '20px' }} />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </TblContainer>
        <TblPagination />
        <CustomDialog
          title="Formulario Noticias"
          openPopup={open}
          setOpenPopup={setOpen}
          maxWidth="md"
        >
          <BlogForm
            setOpenPopup={setOpen}
            update={update}
            flag={flag}
            setFlag={setFlag}
          />
        </CustomDialog>
      </div>
    </>
  )
}
